import { FormattedMessage } from "react-intl";
import { usageQualityOptions } from "constants/Defaults.js";
import NationalTextField from "./NationalTextField";
import NationalSelectField from "./NationalSelectField";

export default function EducationSection({
  register,
  errors,
  dir,
  currentLocale,
}) {
  return (
    <div className="data-form">
      <h5
        className="fw-bold mb-4 text-decoration-underline"
        style={{ color: "var(--main-color)" }}
      >
        <FormattedMessage id="the-educational-qualification" />
      </h5>

      <NationalTextField
        register={register}
        name="academicQualification"
        labelId="main-educational-qualification"
        error={errors?.academicQualification}
      />
      <NationalTextField
        register={register}
        name="academicSpecialization"
        labelId="specialty"
        error={errors?.academicSpecialization}
      />
      <NationalTextField
        register={register}
        name="qualificationSource"
        labelId="where-to-get-it"
        error={errors?.qualificationSource}
      />
      <NationalTextField
        register={register}
        name="qualificationYear"
        labelId="year-get-it"
        type="number"
        error={errors?.qualificationYear}
      />
      <NationalTextField
        register={register}
        name="otherQualifications"
        labelId="other-qualifications"
        error={errors?.otherQualifications}
      />
      <NationalTextField
        register={register}
        name="lastTrainingPrograms"
        labelId="lastTrainingPrograms"
        error={errors?.lastTrainingPrograms}
      />
      <NationalSelectField
        register={register}
        name="computerUsageQuality"
        labelId="computerUsageQuality"
        dir={dir}
        currentLocale={currentLocale}
        options={usageQualityOptions}
      />
      <NationalSelectField
        register={register}
        name="spssUsageQuality"
        labelId="spssUsageQuality"
        dir={dir}
        currentLocale={currentLocale}
        options={usageQualityOptions}
      />
    </div>
  );
}
